/**
 * SN-8295 — a Player Finder card's own location, as the card shows it: city
 * and province/state ("Victoria, British Columbia"). Empty when the card has
 * neither.
 */
export const finderLocationLabel = (
  location?: {
    city?: string | null
    province?: { name?: string | null } | null
  } | null
): string =>
  [location?.city?.trim(), location?.province?.name?.trim()]
    .filter((part): part is string => Boolean(part))
    .join(', ')
